//
//
//
//
import FormComponent from './form.vue';
export default {
  name: 'order-consign-detail',
  props: {
    id: {
      type: String,
      required: false
    },
    action: {
      type: String,
      required: false
    }
  },
  components: {
    FormComponent: FormComponent
  }
};